import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "./service/authService";
import { userList } from "./service/userServices/userServices";
import { oddsData } from "./service/oddsServices/oddsServices";
import matchnameref from './global/matchNameSlice'
import sport from './global/matchSlice'

export const store = configureStore({
  reducer: {
    matchnameref,
    sport,
    [authApi.reducerPath]: authApi.reducer,
    [userList.reducerPath]: userList.reducer,
    [oddsData.reducerPath]: oddsData.reducer,
  },
  middleware: (defaultMiddleware) =>
    defaultMiddleware()
      .concat(authApi.middleware)
      .concat(userList.middleware)
      .concat(oddsData.middleware)
});
